'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ArrowUp = function ArrowUp(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 360 227.3' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M358 180.2l-44.3 43L183.4 89.1 45.3 223.2l-43-44.3L180.7 7.4l4.9-4.8z' })
    )
  );
};
/*eslint-enable */

exports.default = ArrowUp;
//# sourceMappingURL=ArrowUp.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ArrowUp.js